import React from 'react';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';

const LandingPage = () => {
    return (
        <div className="landing-page">
            <Header />

            <div className="hero" style={{ backgroundImage: 'linear-gradient(to right, #4CAF50, #2196F3)' }}>
                <div className="hero-overlay"></div>
                <div className="hero-content">
                    <h1 className="hero-title">Snox - The Photo House</h1>
                    <p className="hero-subtitle">We deliver your event photos with AI technology</p>
                </div>
            </div>

            <div className="container">
                <div className="card mt-4">
                    <div className="text-center mb-4">
                        <h2>Welcome to Snox</h2>
                        <p>
                            At Snox, we use cutting-edge AI technology to identify and deliver your photos
                            directly from events. No more scrolling through hundreds of pictures!
                        </p>
                    </div>

                    <div className="features">
                        <div className="feature-item">
                            <div className="feature-icon">
                                <i className="fa fa-camera"></i>
                            </div>
                            <h3>Easy Registration</h3>
                            <p>Simply register with your selfie at the event through our shared link.</p>
                        </div>

                        <div className="feature-item">
                            <i className="fa fa-robot"></i>
                            <h3>AI-Powered</h3>
                            <p>Our facial recognition technology identifies you in event photos.</p>
                        </div>

                        <div className="feature-item">
                            <i className="fa fa-mobile-alt"></i>
                            <h3>Secure Access</h3>
                            <p>Access your photos securely with a PIN sent to your mobile.</p>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default LandingPage;